Vendd.Scripts.load(function () {

	Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'x-product-details-login', function (envelope) {

		var $context = envelope.message.data.context,
			$controls = $('.x-product-details-login', $context);

		if ($controls.length < 1)
			return;

		$.each($controls, function (i, control) {
			var $control = $(control);
			var $buttons = $('.js-open-login', $control);

			control.openLogin = function () {
				var $loginWidget = $('.x-login-widget').first();
				var $loginButton = $('.js-widget-trigger', $loginWidget).first();
				$loginButton.trigger('click');
			};

			control.scrollToTop = function (complete) {
				var isComplete = false;
				$('html,body').animate({ scrollTop: 0 }, 400, 'swing', function () {
					if (!isComplete) {
						isComplete = true;
						if (typeof complete === 'function') {
							complete();
						}
					}
				});
			};

			$buttons.on('click', function (e) {
				e.preventDefault();

				control.scrollToTop(function () {
					control.openLogin();
				});
			});
		});
	});
});
